import axios from 'axios';
const LOGOUT_SUCCESS = 'auth/logout_success';
const LOGIN_SUCCESS = 'auth/login_success';
const LOGIN_FAIL = 'auth/login_fail';
const initilState = {
    token:null,
    userLoginStatus:'',
    userLoginMsg:''
};
//Reducer
export default (state = initilState, action) => {
    switch (action.type) {
        case LOGOUT_SUCCESS:
            window.localStorage.removeItem('userData');
            window.localStorage.setItem('showWelcomeAlert',false);
            return {
                ...state,
                token:null,
                userLoginStatus:'',
                userLoginMsg:'',
                loginStatus:window.localStorage.setItem('loginStatus',false)
            };
        case LOGIN_SUCCESS:
            const userData ={
                mainData:action.payload,
                id:action.payload.id,
                loginStatus:true,
                applicationStatus:action.payload.applicationStatus,
                veficationStatus:action.payload.veficationStatus
            }
            window.localStorage.setItem('userData',JSON.stringify(userData));
            window.localStorage.setItem('showWelcomeAlert',true);
            return{
                ...state,
                userLoginStatus: action.payload.error,
                userLoginMsg:'',
                loginStatus:window.localStorage.setItem('loginStatus',true)
            };

        case LOGIN_FAIL:
            window.localStorage.removeItem('userData');
            window.localStorage.setItem('loginStatus',false);
            return{
                ...state,
                token:null,
                userLoginStatus: action.payload.error,
                userLoginMsg:action.payload.msg,
                loginStatus:window.localStorage.setItem('loginStatus',false)
            };
        
        default:
            return state;
    }
};

export const logOut = (calledFrom) =>(dispatch) => {
    /*dispatch LOGOUT_SUCCESS action */
    const userD = JSON.parse(window.localStorage.getItem('userData'));
  
    if(userD === null){
        /*header*/
        dispatch({ type: LOGOUT_SUCCESS });
        /**redirect to login page */
        if(calledFrom !=="loginPage"){
            window.location.href = process.env.REACT_APP_FRONTEND_URL+'/login';
        }
        
    }else{
        /*header*/
        const config = {
            headers: {'Content-Type': 'application/json','Authorization' : 'Bearer '+ userD.token}
        }
        axios.post(process.env.REACT_APP_API_URL+'/logout',null, config)
        .then(function(response){
            dispatch({
                type: LOGOUT_SUCCESS,
            });
            /**redirect to login page */
            if(calledFrom !=="loginPage"){
                window.location.href = process.env.REACT_APP_FRONTEND_URL+'/login';
            }
            
        })
        .catch(err =>{
            dispatch({
                type: LOGOUT_SUCCESS,
            })
             /**redirect to login page */
            if(calledFrom !=="loginPage"){
               
                window.location.href = process.env.REACT_APP_FRONTEND_URL+'/login';
            }
            
        })
    }
}

/**user login*/
export const userLogin = (email,phone,type) => dispatch =>{
    /*dispatch LOGOUT_SUCCESS action */
    dispatch({type: LOGOUT_SUCCESS});

    /*header*/
    const config ={
        headers: { 'Content-Type': 'application/json' }
    }
    /*request body*/
    const body = JSON.stringify({email,phone,type});

    axios.post(process.env.REACT_APP_API_URL+'/createApplication', body, config)
        .then(function(response){
            dispatch({
                type: LOGIN_SUCCESS,
                payload: response.data
            });
        })
        .catch(err =>{
            console.log(err)
            dispatch({
                type: LOGIN_FAIL,
                payload: err.response.data
            })
        })
}
  